module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-5.a2838487.svg";